<template>
  <page :loading="loading">
    <template #content>
      <SubTopBar>
      <v-btn text v-if="showAddAccessToken" @click="toAddAccessToken">
        <v-icon>mdi-lock</v-icon>
        <span padding="10px">Create access token</span>
      </v-btn>
      <v-btn text v-if="showAddSshKey" @click="toAddSshKey">
        <v-icon>mdi-key</v-icon>
        <span padding="10px">Add SSH key</span>
      </v-btn>
    </SubTopBar>
    <v-breadcrumbs
      :items="bcItems"
      divider=">"
      class="mt-1"
      large
      />
      <template>
        <v-tabs color="primary" left>
          <v-tab :to="{name: 'AccessTokens'}"> Access tokens </v-tab>
          <v-tab :to="{name: 'SshKeys'}"> SSH keys </v-tab>
          <v-tab :to="{name: 'Authenticator'}">
            Authenticator application
          </v-tab>
        </v-tabs>
        <router-view />
      </template>
    </template>
  </page>
</template>

<script>
export default {
  data() {
    return {
      loading: true
    }
  },
  computed: {
    showAddSshKey: function () {return this.$route.name == 'SshKeys'},
    showAddAccessToken: function () {return this.$route.name == 'AccessTokens'},
    bcItems: function () {
      return [
        {},
        {
          text: "Settings",
          disabled: false,
          exact: true,
          to: {name: 'Settings'}
        },
        {
          text: `${this.$route.meta.bcText}`,
          disabled: false,
          exact: true,
          href: `${this.$route.path}`
        },
      ]}
    
  },
  methods: {
    toAddSshKey() {
      this.$router.push({name: "AddSshKey"})
    },
    toAddAccessToken() {
      this.$router.push({name: "AddAccessToken"})
    }
  },
  mounted() {
    this.loading = false
  }
}
</script>


<style scoped>
div {
  padding: 10px;
}
span {
  padding: 5px 5px;
}
.v-btn {
  margin: 5px 5px;
}
</style>